/* eslint-disable arrow-body-style */
import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import { NavigationService } from '../services/navigation.service';
import { Go, RouterActionTypes } from './router-actions';

export const navigate = createEffect(
  (actions$ = inject(Actions), router = inject(NavigationService)) => {
    return actions$.pipe(
      ofType(Go),
      map(action => action.payload),
      tap(({ path, query: queryParams, extras }) =>
        router.navigate(path, { queryParams, ...extras })
      )
    );
  },
  { functional: true, dispatch: false }
);

export const navigateBack = createEffect(
  (actions$ = inject(Actions), location = inject(Location)) => {
    return actions$.pipe(
      ofType(RouterActionTypes.BACK),
      tap(() => location.back())
    );
  },
  { functional: true, dispatch: false }
);

export const navigateForward = createEffect(
  (actions$ = inject(Actions), location = inject(Location)) => {
    return actions$.pipe(
      ofType(RouterActionTypes.FORWARD),
      tap(() => location.forward())
    );
  },
  { functional: true, dispatch: false }
);
